import { POSTHOG_CONFIG, POSTHOG_TOKEN, POSTHOG_ENABLED } from '~/config';
import posthog from 'posthog-js';

const FlagService = {
	init: () => {
		if(window.Cypress) {
			return;
		}
		// PostHog is initialised in every environment so feature flags can be
		// evaluated (and flag-gated features tested) locally. Analytics capture
		// — events, autocapture, pageviews, session recording — is suppressed
		// outside production/staging so dev/test traffic never pollutes PostHog.
		// Feature-flag evaluation is unaffected: the flags request is separate
		// from event capture, so flags still resolve with capture turned off.
		const captureConfig = POSTHOG_ENABLED
			? {}
			: {
				autocapture: false,
				capture_pageview: false,
				capture_pageleave: false,
				disable_session_recording: true,
				before_send: () => null
			};
		return posthog.init(POSTHOG_TOKEN, { ...POSTHOG_CONFIG, ...captureConfig });
	},
	identify: (session) => {
		if(window.Cypress) {
			return;
		}
		posthog.identify(session._id, {
			name: session.name,
			email: session.emailNormal
		});
	},
	isFeatureEnabled: (featureName) => {
		if(window.Cypress) {
			return true;
		}
		return posthog.isFeatureEnabled(featureName);
	},
	reload: () => {
		if(window.Cypress) {
			return;
		}
		return posthog.reloadFeatureFlags();
	}
};

export default FlagService;
